import { render, staticRenderFns } from "./DetailMembership.vue?vue&type=template&id=5e038654&scoped=true"
import script from "./DetailMembership.vue?vue&type=script&lang=js"
export * from "./DetailMembership.vue?vue&type=script&lang=js"
import style0 from "./DetailMembership.vue?vue&type=style&index=0&id=5e038654&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e038654",
  null
  
)

export default component.exports